// Semantic red→green scale colors for MSI (meetstandaard) matrix questions.
// Color coding applies ONLY to MSI questions (Standard === 'true' — written
// exclusively by the meetstandaard flows) on a 5-point scale. Negative
// statements ("Ik kan mij niet goed concentreren") reverse the palette:
// agreeing with a negative statement is bad, so column 5 shows red.
// posNeg comes from the MSI API and is persisted on MatrixQuestionRows;
// only the exact string 'negative' flips (mixed legacy shapes exist).
// AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches

export const MATRIX_SCALE_COLORS = ['#e74c3c', '#e67e22', '#f1c40f', '#90ee90', '#2ecc71'];

/**
 * @param {object} args
 * @param {{Standard?: string}|null|undefined} args.field - QuestionnaireFields doc
 * @param {{posNeg?: string|boolean}|null|undefined} args.row - MatrixQuestionRows doc
 * @param {number} args.colIndex - 0-based column index
 * @param {number|undefined} args.totalCols - Number of matrix columns
 * @returns {string|undefined} CSS color for the cell, or undefined (no coloring)
 */
const getMatrixCellColor = ({ field, row, colIndex, totalCols }) => {
  if (!field || field.Standard !== 'true') return undefined;
  if (totalCols !== 5) return undefined;
  const isNegative = row?.posNeg === 'negative';
  const index = isNegative ? (4 - colIndex) : colIndex;
  return MATRIX_SCALE_COLORS[index];
};

export default getMatrixCellColor;
